.root {
  display: flex;
  flex-direction: column;
  place-items: left;
  --meter-width: 64px;
  --handle-color: var(--mantine-primary-color-filled);
}

.root:has(.labelFloat) {
  width: 10rem; /* space out the flyout for the labels outside the layout. switch to grid layout to fix this */
}

.rlsColor {
  --handle-color: var(--mantine-color-red-6);
}

.control {
  display: flex;
  place-items: center;
  margin-bottom: 8px;
}

.meterContainer {
  position: relative;
  width: var(--meter-width);
  height: 256px;
  background-color: light-dark(var(--mantine-color-gray-2), var(--mantine-color-dark-8));
  border-radius: 5px;
  overflow: hidden;
}

.meterValueFill {
  position: absolute;
  inset-inline: 0;
  bottom: 0;
  /* transition: all;
  transition-duration: 300ms;
  transition-timing-function: ease-in-out; */
  background-color: light-dark(var(--mantine-color-gray-5), var(--mantine-color-dark-3));
}

.meterValueFillActive {
  background-color: light-dark(var(--mantine-color-green-5), var(--mantine-color-green-6));
}

.meterThresholdLine {
  position: absolute;
  inset-inline: 0;
  height: 2px;
  background-color: var(--handle-color);
}

.controlsContainer {
  position: relative;
  margin-left: 8px;
  width: 40px;
  height: 256px;
}

.dragHandleContainer {
  position: absolute;
  display: flex;
  place-items: center;
  left: 0;
  gap: 6px;
  cursor: ns-resize;
  touch-action: none;
}

.dragHandleOffset {
  flex-direction: column;
  align-items: center;
  gap: 6px;
}

.dragHandleOffset:nth-child(2) {
  left: 24px;
}

.dragHandle {
  width: 16px;
  height: 16px;
  border-radius: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  background-color: var(--handle-color);
}

.dragHandleContainer:focus .dragHandle {
  outline: 2px solid var(--handle-color);
  outline-offset: 2px;
}

.handleLabel {
  font-size: 70%;
  color: white;
  background-color: var(--handle-color);
  border-radius: var(--mantine-radius-xs);
  padding: 1px 2px;
}

.bottomControls {
  width: var(--meter-width);
  font-size: 80%;
}

.bottomControls p {
  margin: 0.4em 0;
}

.bottomControls .valueRow {
  margin: 0 0;
  line-height: 1.3;
}

.labelFloat {
  height: 0;
  position: relative;
  left: 5rem;
  margin-top: calc(-1 * var(--mantine-spacing-xs));
}

.fsrIndicator {
  align-self: center;
  height: 2em;
  width: 2em;
  border: 1px solid light-dark(var(--mantine-color-gray-7), var(--mantine-color-gray-5));
}

.bad {
  color: var(--mantine-color-red-6);
  font-weight: 600;
  text-wrap: nowrap;
}
